// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"358":"live-streaming","393":"study-ai","594":"about","626":"study","977":"medical-code"}[chunkId] || chunkId) + "." + {"209":"d39448d8","358":"6a3cb7c9","393":"1d413ed8","594":"6e8aa45d","626":"f7173c55","977":"5803b0b5"}[chunkId] + ".css";
};